import React, { useState } from "react"
import  "../AnbarGardaniStyle.css";

const LocationModal=(props)=>{
    
    return(
        <React.Fragment>
          
<div className="location_modal text-right">
<div className="location_modal_box">
    <div className="location_modal_header bg-dark p-2">
<span className=" w-100 text-right text-white">اخطار</span>
    </div>
    <div className="p-4 text-center">
<p>
      این محصول برای لوکیشن  
     <span className="px-1 text-info"> {props.oldLocation}</span>
      میباشد و موجودی آن 
      <span className="px-1 text-info"> {props.stock}</span>
      میباشد
       ایا به این لوکیشن منتقل شود ؟   

</p>
<p>
</p>
<hr />
<div className="row text-right my-3 " style={{direction:"rtl"}}>
    <div className="col-6 text-left">
    <button className="btn btn-success w-50" onClick={props.apply}>بله</button>
    </div>
    <div className="col-6  text-right">

    <button className="btn btn-danger w-50" onClick={props.close}>خیر</button>
    </div>
    </div>
    </div>
   

</div> 
</div> 
            </React.Fragment>
        )
}
export default LocationModal;